import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';

import { ChatMessage } from '../../../types/Chatbot';

@Component({
  selector: 'app-chat-message',
  imports: [CommonModule, MarkdownModule],
  templateUrl: './chat-message.component.html',
  styleUrl: './chat-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageComponent {
  public readonly message = input.required<ChatMessage>();
}
